export const MultiDatumMark = [ "line", "area", "trail" ];

export function isMultiDatumMark(type) {
    return MultiDatumMark.includes(type);
}

export function curveTypeTransform(type, direction) {
    return "monotone" === type ? "horizontal" === direction ? "monotoneY" : "monotoneX" : type;
}
//# sourceMappingURL=common.js.map
